import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import MoonshotsSetupImg from "../../../assets/images/needleeye-phone-right.svg";
import istoreImg from "../../../assets/images/istore-icon.svg";
import androidImg from "../../../assets/images/googleplay-icon.svg";

import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";

const MoonshotsSetup = () => {
  const navigate = useNavigate();

  const androidURL =
    "https://play.google.com/store/apps/details?id=com.needleeye.app";

  const iosURL = "https://apps.apple.com/in/app/needleeye/id6761813405";

  const handleProceed = () => {
    // setShowVerification(true);
    navigate("/authentication");
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
        {/* Left Section */}
        <div className="w-full md:w-1/2 flex justify-center items-center px-4 md:px-6 lg:px-8">
          <img
            src={MoonshotsSetupImg}
            alt="Moonshots setup"
            className="object-contain w-full max-w-[520px] h-auto rounded-3xl"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-4 my-[5%]" />

        {/* Right Section */}
        <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
          <div className="max-w-[920px]">
            {/* Heading */}
            <h2
              className="font-semibold mb-4 leading-snug outer-font-color
       app-video-overlay"
            >
              Get the NeedleEye App Running
            </h2>

            {/* Body */}
            <p
              className="mb-4 leading-relaxed outer-font-color
      app-body"
            >
              If you have the NeedleEye App already installed on your device,
              open the app and click on{" "}
              <span className="font-medium">"Proceed"</span>.
            </p>

            <p
              className="mb-6 leading-relaxed outer-font-color
        app-body"
            >
              If you haven't installed the NeedleEye App yet, please scan the QR
              code from your phone. Download it and sign up using your phone
              number. Click <span className="font-medium">"Proceed"</span> once
              done.
            </p>

            {/* QR Section */}
            <div className="flex flex-col sm:flex-row gap-8 sm:gap-12 justify-center mt-8 mb-8 md:mb-12">
              <div className="flex flex-col items-center gap-2">
                <img
                  src={androidImg}
                  alt="Android store"
                  className="h-8 md:h-10"
                />
                <QRCodeSVG
                  value={androidURL}
                  className="w-[140px] h-[140px] sm:w-[160px] sm:h-[160px] md:w-[180px] md:h-[180px]"
                />
              </div>

              <div className="flex flex-col items-center gap-2">
                <img src={istoreImg} alt="iOS store" className="h-8 md:h-10" />
                <QRCodeSVG
                  value={iosURL}
                  className="w-[140px] h-[140px] sm:w-[160px] sm:h-[160px] md:w-[180px] md:h-[180px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Buttons container at the bottom */}
      <div className="mt-auto w-full flex justify-end pb-4 pr-4">
        <button
          onClick={handleProceed}
          className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
        >
          Proceed
          <img src={arrowImg} alt="arrow" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
        ©{" "}
        {new Date().getFullYear() > 2026
          ? `2026-${new Date().getFullYear()}`
          : "2026"}
        , Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default MoonshotsSetup;
